import { IChannel } from '@giphy/js-types'
import React, { PureComponent } from 'react'
import { channelSearch } from 'shared/api'
import { SearchOptionsPageData } from 'shared/types/page-data'
import Header from '../components/header/header'

type Props = {
    searchInfo: SearchOptionsPageData
    totalCount?: number
}
class HeaderContainer extends PureComponent<Props, { channels: undefined | IChannel[] }> {
    state = {
        channels: undefined,
    }
    async componentDidMount() {
        const { searchInfo } = this.props
        if (searchInfo) {
            const channels = await channelSearch(searchInfo.term)
            this.setState({ channels })
        }
    }
    render() {
        const { searchInfo, totalCount } = this.props
        const { channels } = this.state
        return <Header searchInfo={searchInfo} channels={channels} totalCount={totalCount} />
    }
}

export default HeaderContainer
